<div class="d-flex flex-column min-vh-100 bg-dark">
  <div class="gridster-wrapper flex-grow-1 overflow-auto" style="height: calc(100vh - 80px);">
    <gridster [options]="options">
      @for (item of dashboard; track item) {
      <gridster-item [item]="item">
        <!-- Logo -->
        @if (item.hasContent && item.contentType === 'logo') {
        <div class="gridster-item-content d-flex justify-content-center align-items-center text-center">
          <img height="180" src="../assets/logo-light-text.png" alt="ATP Logo">
        </div>
        }
        <!-- Warnings -->
        @if (item.hasContent && item.contentType === 'warnings') {
        <div class="gridster-item-content">
          <table id="table" class="table-sm table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @if (tableRows === 0) {
              <tr class="tr-success">
                <td>
                  <img width="50" src="https://d1j8pt39hxlh3d.cloudfront.net/uploads/party_face_256_1.gif"
                    alt="No warnings">
                  Er zijn op dit moment geen meldingen.
                </td>
              </tr>
              }
              @if (AtpData.CRMQueue > 5) {
              <tr class="tr-warning">
                <td>Er staan <b>{{ AtpData.CRMQueue }}</b> CRM taxaties in de queue.</td>
              </tr>
              }
              @if (AtpData.TransportQueue == 1) {
              <tr class="tr-warning">
                <td>Er staat <b>{{ AtpData.TransportQueue }}</b> transportopdracht in de queue.</td>
              </tr>
              }
              @if (AtpData.TransportQueue > 1) {
              <tr class="tr-warning">
                <td>Er staan <b>{{ AtpData.TransportQueue }}</b> transportopdrachten in de queue.</td>
              </tr>
              }
              @for (item of AtpData.AwsQueue; track item) {
              @if (item.attributes.ApproximateNumberOfMessages > 0) {
              <tr class="tr-warning">
                <td>DLQ - <b>{{ item.name }}</b> heeft <b>{{ item.attributes.ApproximateNumberOfMessages }}</b> items.
                </td>
              </tr>
              }
              }
              @for (item of AtpData.AwsAlerts; track item) {
              <tr class="tr-danger">
                <td>AWS - {{ item.state }} - {{ item.name }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
        <!-- Time -->
        @if (item.hasContent && item.contentType === 'time') {
        <div class="gridster-item-content d-flex justify-content-center align-items-center">
          <h1 class="display-1 m-0">{{ currentTime | date:'HH:mm:ss' }}</h1>
        </div>
        }
        <!-- Network -->
        @if (item.hasContent && item.contentType === 'network') {
        <div class="gridster-item-content d-flex justify-content-center align-items-center text-center">
          <div>
            <h2>Internetverbinding</h2>
            @if (AtpData.externalIP === '92.65.65.134') {
            <h1 class="text-success"><b>OK</b></h1>
            } @else {
            <h1 class="text-warning">Mobiele data</h1>
            }
            @if (AtpData.ping < 200) { <p>{{ AtpData.ping | number:'1.0-0' }} ms ping</p>
              }
              @if (AtpData.ping > 200) {
              <p class="text-danger">{{ AtpData.ping | number:'1.0-0' }} ms ping</p>
              }
          </div>
        </div>
        }
        <!-- Crypto Cards -->
        @for (type of ['bitcoin', 'etherium', 'cardano', 'quant']; track type) {
        @if (item.hasContent && item.contentType === type) {
        <div class="gridster-item-content d-flex justify-content-center align-items-center text-center">
          @if (AtpData[type.charAt(0).toUpperCase() + type.slice(1) + 'Price']; as price) {
          <div>
            <img class="imageLogo mb-2" [src]="'/assets/' + (type === 'etherium' ? 'etherium.svg.png' : type + '.png')"
              [alt]="type">
            <h1>
              €<b>{{ price.data.amount | number: type === 'cardano' || type === 'quant' ? '1.2-2' : '2.2-2':'nl-NL' }}</b>
            </h1>
          </div>
          }
        </div>
        }
        }
      </gridster-item>
      }
    </gridster>
  </div>

  <!-- Footer -->
  <footer class="page-footer mt-auto">
    <div class="text-center py-2 small text-light">
      <div class="d-flex justify-content-center align-items-center gap-4">
        <div>
          <i class="Blink fa fa-circle text-danger"></i>&nbsp;
          LIVE - {{ currentTime | date:'HH:mm:ss' }} Versie: {{ version }}
        </div>
        <div>
          <button class="btn btn-sm btn-outline-light" (click)="logout()">
            <i class="fas fa-sign-out-alt me-1"></i>Uitloggen
          </button>
        </div>
      </div>
    </div>
  </footer>
</div>